import { render, staticRenderFns } from "./BalancesPlanDetailsInfo.vue?vue&type=template&id=5dbba1c6&scoped=true&"
import script from "./BalancesPlanDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbba1c6",
  null
  
)

export default component.exports